import { useAppSelector } from "../hooks";

export interface DialogComponent {
    id: number;
    component: (props: any) => React.JSX.Element;
    props: { [propName: string]: unknown; dialogId?: number };
}

const DialogOutlet = () => {
    const dialogList = useAppSelector((state) => state.dialogs.componentList);

    return (
        <>
            {dialogList.map((c: DialogComponent, i: number) => (
                <div className="dialog" key={i}>
                    <div className="dialog-inner">{c.component(c.props)}</div>
                </div>
            ))}
        </>
    );
};

export default DialogOutlet;
